import { SearchDocumentType, } from '../../api/api.types';
import { ClientSearchDocumentBuilder } from '../sdk.builder';
function mockImage(name) {
    return {
        name: name,
        width: 1000,
        height: 1000,
    };
}
var MOCK_URL = 'https://wix.com';
var PAGES = [
    {
        id: '61312e36-661f-11eb-ae93-0242ac130002',
        documentType: SearchDocumentType.Pages,
        title: 'mockedSearchResults.pages.5.title',
        documentImage: mockImage('b88f2d5da73042e2b86399ab9f21367f.jpg'),
        description: 'mockedSearchResults.pages.5.description',
        url: MOCK_URL,
    },
    {
        id: '61312e36-661f-11eb-ae93-0242ac130002',
        documentType: SearchDocumentType.Pages,
        title: 'mockedSearchResults.pages.4.title',
        documentImage: mockImage('7f0f209fce404b8a8b21ee10de5c4118.jpg'),
        description: 'mockedSearchResults.pages.4.description',
        url: MOCK_URL,
    },
    {
        id: '61312e36-661f-11eb-ae93-0242ac130002',
        documentType: SearchDocumentType.Pages,
        title: 'mockedSearchResults.pages.3.title',
        documentImage: mockImage('5e7d2ea14bb841b4ad61e1a43c4fdfad.jpg'),
        description: 'mockedSearchResults.pages.3.description',
        url: MOCK_URL,
    },
    {
        id: '61312e36-661f-11eb-ae93-0242ac130002',
        documentType: SearchDocumentType.Pages,
        title: 'mockedSearchResults.pages.2.title',
        documentImage: mockImage('1a77bf468f24468b954aba15ddd8b1e2.png'),
        description: 'mockedSearchResults.pages.2.description',
        url: MOCK_URL,
    },
    {
        id: '61312e36-661f-11eb-ae93-0242ac130002',
        documentType: SearchDocumentType.Pages,
        title: 'mockedSearchResults.pages.1.title',
        documentImage: mockImage('3273c6e2911e44059093e6011be353a5.jpg'),
        description: 'mockedSearchResults.pages.1.description',
        url: MOCK_URL,
    },
];
var PRODUCT_TITLE = 'mockedSearchResults.products.1.title';
var PRODUCT_DESCRIPTION = 'mockedSearchResults.products.1.description';
var PRODUCTS = [
    {
        id: '61312e36-661f-11eb-ae93-0242ac130002',
        documentType: SearchDocumentType.Products,
        title: PRODUCT_TITLE,
        documentImage: mockImage('a9ff3b_9928686dcfa740bd802821d0b6f4ac03.jpg'),
        description: PRODUCT_DESCRIPTION,
        discountedPrice: '$85.00',
        url: MOCK_URL,
    },
    {
        id: '61312e36-661f-11eb-ae93-0242ac130002',
        documentType: SearchDocumentType.Products,
        title: PRODUCT_TITLE,
        documentImage: mockImage('a9ff3b_1eec973ae9eb43f4bca9876e5d90f6fa.jpg'),
        description: PRODUCT_DESCRIPTION,
        discountedPrice: '$20.00',
        url: MOCK_URL,
    },
    {
        id: '61312e36-661f-11eb-ae93-0242ac130002',
        documentType: SearchDocumentType.Products,
        title: PRODUCT_TITLE,
        documentImage: mockImage('a9ff3b_119100d8c0144221b2f6733f4d205d2e.jpg'),
        description: PRODUCT_DESCRIPTION,
        discountedPrice: '$10.00',
        url: MOCK_URL,
    },
    {
        id: '61312e36-661f-11eb-ae93-0242ac130002',
        documentType: SearchDocumentType.Products,
        title: PRODUCT_TITLE,
        documentImage: mockImage('a9ff3b_c6158b4d41784ae8b08337a331e1de7f.jpg'),
        description: PRODUCT_DESCRIPTION,
        discountedPrice: '$25.00',
        url: MOCK_URL,
    },
    {
        id: '61312e36-661f-11eb-ae93-0242ac130002',
        documentType: SearchDocumentType.Products,
        title: PRODUCT_TITLE,
        documentImage: mockImage('a9ff3b_03155a7e79bd4cca9aaf3f0e98378100.jpg'),
        description: PRODUCT_DESCRIPTION,
        discountedPrice: '$7.50',
        url: MOCK_URL,
    },
    {
        id: '61312e36-661f-11eb-ae93-0242ac130002',
        documentType: SearchDocumentType.Products,
        title: PRODUCT_TITLE,
        documentImage: mockImage('a9ff3b_5bc54b597d67423d8022157cef968f7b.jpg'),
        description: PRODUCT_DESCRIPTION,
        discountedPrice: '$15.00',
        url: MOCK_URL,
    },
    {
        id: '61312e36-661f-11eb-ae93-0242ac130002',
        documentType: SearchDocumentType.Products,
        title: PRODUCT_TITLE,
        documentImage: mockImage('a9ff3b_5e32b6d9419343c29c68e9173b5461e0.jpg'),
        description: PRODUCT_DESCRIPTION,
        discountedPrice: '$85.00',
        url: MOCK_URL,
    },
    {
        id: '61312e36-661f-11eb-ae93-0242ac130002',
        documentType: SearchDocumentType.Products,
        title: PRODUCT_TITLE,
        documentImage: mockImage('a9ff3b_ea68bd8398ac489a8e4e8b99755f96b0.jpg'),
        description: PRODUCT_DESCRIPTION,
        discountedPrice: '$40.00',
        url: MOCK_URL,
    },
    {
        id: '61312e36-661f-11eb-ae93-0242ac130002',
        documentType: SearchDocumentType.Products,
        title: PRODUCT_TITLE,
        documentImage: mockImage('a9ff3b_849d96e85f044bc7ae0a47f78d9a898b.jpg'),
        description: PRODUCT_DESCRIPTION,
        discountedPrice: '$130.00',
        url: MOCK_URL,
    },
    {
        id: '61312e36-661f-11eb-ae93-0242ac130002',
        documentType: SearchDocumentType.Products,
        title: PRODUCT_TITLE,
        documentImage: mockImage('a9ff3b_18ef3d9c8058444ea08059329237a1f2.jpg'),
        description: PRODUCT_DESCRIPTION,
        discountedPrice: '$45.00',
        url: MOCK_URL,
    },
    {
        id: '61312e36-661f-11eb-ae93-0242ac130002',
        documentType: SearchDocumentType.Products,
        title: PRODUCT_TITLE,
        documentImage: mockImage('a9ff3b_f9b427f2017641468a0b939aa26777b5.jpg'),
        description: PRODUCT_DESCRIPTION,
        discountedPrice: '$95.00',
        url: MOCK_URL,
    },
    {
        id: '61312e36-661f-11eb-ae93-0242ac130002',
        documentType: SearchDocumentType.Products,
        title: PRODUCT_TITLE,
        documentImage: mockImage('a9ff3b_ed3b544c319b4fad9c222c791a997832.jpg'),
        description: PRODUCT_DESCRIPTION,
        discountedPrice: '$120.00',
        url: MOCK_URL,
    },
];
var BLOGS = [
    {
        id: '61312e36-661f-11eb-ae93-0242ac130002',
        documentType: SearchDocumentType.Blogs,
        title: 'mockedSearchResults.blog.3.title',
        documentImage: mockImage('a27d24_74a5c4593cc1454683305dbaa50c80cb~mv2_d_1880_1560_s_2.png'),
        description: 'mockedSearchResults.blog.2.description',
        url: MOCK_URL,
    },
    {
        id: '61312e36-661f-11eb-ae93-0242ac130002',
        documentType: SearchDocumentType.Blogs,
        title: 'mockedSearchResults.blog.2.title',
        documentImage: mockImage('a27d24_f116a7916f5544a79f92d43b4247a457~mv2_d_2845_1900_s_2.jpg'),
        description: 'mockedSearchResults.blog.2.description',
        url: MOCK_URL,
    },
    {
        id: '61312e36-661f-11eb-ae93-0242ac130002',
        documentType: SearchDocumentType.Blogs,
        title: 'mockedSearchResults.blog.1.title',
        documentImage: mockImage('a27d24_e1ac8887d0e04dd5b98fb4c263af1180~mv2_d_4915_3277_s_4_2.jpg'),
        description: 'mockedSearchResults.blog.1.description',
        url: MOCK_URL,
    },
];
var ALL_TYPES = [
    PAGES[0],
    PRODUCTS[0],
    BLOGS[0],
    PAGES[1],
    PRODUCTS[1],
    BLOGS[1],
    PAGES[2],
    PRODUCTS[2],
    BLOGS[2],
    PAGES[3],
    PRODUCTS[3],
    PAGES[4],
    PRODUCTS[4],
];
function shiftBasedOnQuery(query) {
    // shift can be the same for some queries, resulting in the same mock results. oh well
    if (!query) {
        return 0;
    }
    var shift = 0;
    var length = query.length;
    for (var i = 0; i < length; i++) {
        shift = (shift + query.charCodeAt(i)) % 100;
    }
    return shift;
}
function shiftBasedOnPagination(skip) {
    return Math.floor(skip / 10);
}
function mockResultsMapper(mock) {
    var builder = new ClientSearchDocumentBuilder();
    builder.withTitle(mock.title);
    builder.withDescription(mock.description);
    builder.withDocumentType(mock.documentType);
    builder.withImage(mock.documentImage);
    if (mock.documentType === SearchDocumentType.Products) {
        builder.withPrice(mock.discountedPrice);
    }
    return builder.getResponse();
}
function generateMockResults(mocks, config) {
    var documents = mocks.map(mockResultsMapper);
    // reversing to avoid the same search results
    // on "empty_query + page_after_first" and "some_query + page_1",
    // because in both cases we just shift/cycle/rotate mock data (`resultsShift`)
    var query = config.query === '*' ? '' : config.query;
    if (!query) {
        documents.reverse();
    }
    var resultsShift = (shiftBasedOnQuery(query) + shiftBasedOnPagination(config.skip)) %
        documents.length;
    var results = [];
    var counter = resultsShift;
    for (var i = 0; i < config.limit; i++) {
        if (counter >= documents.length) {
            counter = 0;
        }
        results.push(documents[counter]);
        counter++;
    }
    return results;
}
export function getSearchResults(config) {
    if (config.limit === 0) {
        return [];
    }
    var mocks = [];
    switch (config.documentType) {
        case SearchDocumentType.Products:
            mocks = PRODUCTS;
            break;
        case SearchDocumentType.Pages:
            mocks = PAGES;
            break;
        case SearchDocumentType.Blogs:
            mocks = BLOGS;
            break;
        default:
            mocks = ALL_TYPES;
    }
    return generateMockResults(mocks, {
        limit: config.limit,
        skip: config.skip,
        query: config.query,
    });
}
//# sourceMappingURL=searchResults.js.map